import { render, staticRenderFns } from "./delivery-point.vue?vue&type=template&id=5ef2cc0a&scoped=true&"
import script from "./delivery-point.vue?vue&type=script&lang=js&"
export * from "./delivery-point.vue?vue&type=script&lang=js&"
import style0 from "./delivery-point.vue?vue&type=style&index=0&id=5ef2cc0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2cc0a",
  null
  
)

export default component.exports